// extracted by mini-css-extract-plugin
export default {"menuItem":"page-display_menuItem__9swmj"};